<div class="modal-header">
    <h5 class="modal-title">
        <i class="fa-solid fa-wand-magic-sparkles me-2"></i>
        AI Generator
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <p class="fw-bold">Be specific about what you want. The more detail, the better the result.</p>
            </div>
            <div class="col-xl-6" [class.col-xl-12]="!hasGenerated() && !isGenerating()">
                <div class="mb-4">
                    <sf-input-textarea
                        label="What would you like to generate?"
                        formControlName="prompt"
                        [rows]="3"
                        [placeholder]="getPlaceholder()"
                        [maxLength]="config.maxLength"></sf-input-textarea>

                    @if (form.controls.prompt.invalid && form.controls.prompt.touched) {
                        <div class="text-danger small mt-1">Please enter at least 10 characters</div>
                    }
                </div>

                <b>Write in the following style</b>
                <div class="d-flex mb-3">
                    <button
                        sfButton
                        type="button"
                        [active]="form.controls.style.value === 1"
                        (click)="form.controls.style.setValue(1)">
                        Strict
                    </button>
                    <button
                        sfButton
                        type="button"
                        [active]="form.controls.style.value === 2"
                        (click)="form.controls.style.setValue(2)">
                        Flexible
                    </button>
                    <button
                        sfButton
                        type="button"
                        [active]="form.controls.style.value === 3"
                        (click)="form.controls.style.setValue(3)">
                        Casual
                    </button>
                </div>

                <div class="d-grid mb-4">
                    <button
                        sfButton
                        color="primary"
                        icon="wand-magic-sparkles"
                        [disabled]="form.controls.prompt.invalid || isGenerating()"
                        (click)="generate()">
                        {{ hasGenerated() ? 'Regenerate' : 'Generate with AI' }}
                    </button>
                </div>
            </div>
            <div [hidden]="!isGenerating() && !hasGenerated()" class="col-xl-6">
                <!-- Generated Text -->
                @if (hasGenerated()) {
                    <div class="border border-1 bg-success bg-opacity-10 p-3 rounded">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label for="generatedText" class="form-label fw-semibold mb-0"> Generated Text </label>
                            <button
                                sfButton
                                type="button"
                                size="sm"
                                icon="refresh"
                                color="secondary"
                                (click)="regenerate()"
                                [disabled]="isGenerating()">
                                Regenerate
                            </button>
                        </div>
                        <div class="generated-text-container">
                            <textarea
                                id="generatedText"
                                class="form-control"
                                formControlName="generatedText"
                                rows="8"
                                placeholder="Generated text will appear here..."></textarea>
                        </div>
                        <div class="form-text">
                            <i class="fa-solid fa-lightbulb me-1"></i>
                            You can edit the generated text before confirming
                        </div>
                    </div>
                }

                @if (isGenerating()) {
                    <div class="text-center py-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Generating...</span>
                        </div>
                        <p class="mt-2 text-body-secondary">
                            <i class="fa-solid fa-sparkles me-1"></i>
                            AI is generating your text...
                        </p>
                    </div>
                }
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
        <i class="fa-solid fa-xmark me-1"></i>
        Cancel
    </button>
    <button sfButton color="primary" icon="check" [disabled]="!hasGenerated() || isGenerating()" (click)="confirm()">
        Confirm & Use Text
    </button>
</div>
